module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_fm1_r1"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_fm2_r1"
    }
  }, [_vm._v("The AFP Fund Development Series")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_fm2_r1#h1"
    }
  }, [_vm._v("THE ASSOCIATION OF FUNDRAISING PROFESSIONALS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_fm2_r1#h2"
    }
  }, [_vm._v("2006-2007 AFP PUBLISHING ADVISORY COMMITTEE")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_prf_r1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ata_r1"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ata_r1#h1"
    }
  }, [_vm._v("SIMONE P. JOYAUX, ACFRE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ata_r1#h2"
    }
  }, [_vm._v("TOM AHERN, ABC")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1"
    }
  }, [_vm._v("CHAPTER 1 - Beginning at the Beginning")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1#h1"
    }
  }, [_vm._v("WHY THE LARGER CONTEXT MATTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1#h2"
    }
  }, [_vm._v("PHILOSOPHICAL FRAMEWORK")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1#h3"
    }
  }, [_vm._v("EFFECTIVE ORGANIZATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1#h4"
    }
  }, [_vm._v("EFFECTIVE FUND DEVELOPMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1#h5"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c01_r1#h6"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c02_r1"
    }
  }, [_vm._v("INTERMEZZO #1 - Why?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c02_r1#h1"
    }
  }, [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c03_r1"
    }
  }, [_vm._v("CHAPTER 2 - The Red Pants Factor")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c03_r1#h1"
    }
  }, [_vm._v("FINDING YOUR OWN “RED PANTS” FACTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c03_r1#h2"
    }
  }, [_vm._v("A POSTSCRIPT FROM BLACK DRESS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c03_r1#h3"
    }
  }, [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c04_r1"
    }
  }, [_vm._v("INTERMEZZO #2 - What Do All the Words Mean?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c04_r1#h1"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1"
    }
  }, [_vm._v("CHAPTER 3 - Key Components of Effective Organizations")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h1"
    }
  }, [_vm._v("ADOPT AN ORGANIZATIONAL DEVELOPMENT APPROACH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h2"
    }
  }, [_vm._v("BUILD A CULTURE OF PHILANTHROPY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h3"
    }
  }, [_vm._v("PERSONAL AND ORGANIZATIONAL COMMITMENT TO CONVERSATION AND QUESTIONING,  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h4"
    }
  }, [_vm._v("VALUE OF RESEARCH—YOUR OWN AND THAT OF OTHERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h5"
    }
  }, [_vm._v("QUALIFIED OPINIONS ONLY, PLEASE!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h6"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#h7"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4 - What Relationships Are and Why We Have Them")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RELATIONSHIPS ARE EVERYTHING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TYPES OF RELATIONSHIPS IN THE NONPROFIT/NGO SECTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RELATIONSHIPS ARE DEFINITELY NOT TRANSACTIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DO DONORS REALLY WANT RELATIONSHIPS?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WATCH A GOOD RELATIONSHIP BUILDER")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEY CONCEPTS IN RELATIONSHIP BUILDING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c06_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 4A  - Values and Mission of the Equity Action Fund at the Rhode Island Foundation")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5 - Five Rather Deadly Sins")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIN #1: SEPARATING FUND DEVELOPMENT FROM PHILANTHROPY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIN #2: TREATING GIVING AS A FINANCIAL TRANSACTION RATHER THAN AN EMOTIONAL ACT")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIN #3: TRESPASSING ON PERSONAL AND PROFESSIONAL RELATIONSHIPS. PLEASE PROMISE  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIN #4: UNIVERSALIZING YOUR OWN PASSION. INSTEAD, FIND THEIRS—OR LEAVE THEM  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIN #5: ASKING PREMATURELY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOT SINS BUT CERTAINLY WORRIES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c07_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERMEZZO #3 - Direct Mail and Relationship Building")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 - Eight Steps to Develop and Nurture Relationships")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEVELOPING YOUR RELATIONSHIP-BUILDING PROGRAM")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEPS IN RELATIONSHIP BUILDING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c09_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 6A  -  Evaluating Prospect Interest, Readiness, and Capacity to Give  ...")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 - Identify the Predisposed")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHO ARE THE PREDISPOSED?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUND DEVELOPMENT PROFESSIONALS HELP ORGANIZATIONS IDENTIFY THE PREDISPOSED")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CREATING OPPORTUNITIES FOR PEOPLE TO SELF-IDENTIFY AS PREDISPOSED")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 7A  - Learning About People Through Conversation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c10_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASSIGNMENT")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 - Understanding the Fundamentals of Marketing and Communications")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMUNICATIONS: FOR MANY, IT’S ALL THEY KNOW OF YOU")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUND DEVELOPMENT IS A TYPE OF MARKETING, AND USES THE SAME METHODS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IT’S NOT WHAT YOU’RE SELLING, IT’S WHAT THEY’RE BUYING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TARGETING: HOW YOU FIND NEEDLES IN A HAYSTACK")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEGMENTATION: HOW YOU INCREASE PENETRATION OF A TARGET MARKET")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FREQUENCY AND REACH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT IS BRANDING?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c11_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - Emotions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ORBITOFRONTAL DAMAGE AND ITS IMPLICATIONS FOR FUNDRAISERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMOTIONAL TRIGGERS: AN INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UP TO 135 TRIGGERS TO CHOOSE FROM")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMOTIONAL TWINSETS: RAISE THE PROBLEM, BE THE SOLUTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c12_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 9A  - W. Gerrod Parrott’s List of Emotions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - Relationship Building: Details about Steps #3 and #5")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEP #3 IN THE RELATIONSHIP-BUILDING PROCESS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A REMINDER ABOUT STEP #4")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEP #5: NURTURE THE RELATIONSHIP TO DEVELOP COMMITMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 10A  - Building Relationships With Your Constituents")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 10B  - Member Survey of the Audubon Society of Rhode Island")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 10C  - E-Mail Survey from The Audubon Society of Rhode Island")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c13_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 10D  - Women’s Fund of Rhode Island Marking Milestones Brochure")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - Creating Your Relationship-Building Plan")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c14_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOD PROCESS PRODUCES THEBESTRESULTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c14_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLAN PRACTICALITIES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c14_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A DIFFERENT APPROACH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c14_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c14_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - Planning Donor Communications")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c15_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c15_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WRITING A PLAN")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c15_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BUILDING AN ANNUAL DONOR/MEDIA COMMUNICATIONS CALENDAR ON THE SCHWARTZ PLAN")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c15_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - Characteristics of Effective Communications")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACTION IS THE OBJECTIVE.READING IS OPTIONAL")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AN HON EST-TO-GOODN ESS SECRET TO SUCCESS: WRITE A CREATIVE BRIEF FIRST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THERE’S AN ONSLAUGHT, AND YOU’RE PART OF THE PROBLEM")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOU’RE SELLING FEELINGS, ESPECIALLY HOPE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOU’RE SELLING A FEELING OF IMPORTANCE, TOO")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTEREST ME (OR ELSE)")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW TO INTEREST DONORS AND PROSPECTS: THE BIG FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW TO INTEREST ANYONE: FOUR CHANCES TO WIN")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SELF-INTEREST: WHY GREED IS GOOD (FOR YOUR ORGANIZATION)")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAKE OFFERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PASSING THE “YOU” TEST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DON ’T TALK SO MUCH ABOUT WHAT YOU DO. TALK ABOUT WHY IT MATTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAVE THEMES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOU’VE HEARD OF “VALUES VOTERS”? MEET “VALUES GIVERS”")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c16_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERMEZZO #4 - What’s the Role of a Fundraiser?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - Are You Really Donor—Centered? Are Your Donors Truly Loyal?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOME FACTS ABOUT DONOR RETENTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DONOR-CENTRISM: THE NEW OLD THING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIMPLE DEMANDS OF DONOR-CENTRICITY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DONOR LOYALTY AND DONOR-CENTRISM: INEXTRICABLY LINKED")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT IS LOYALTY?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CURRENT DONORS COME FIRST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HELPING YOUR DONORS DREAM")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACQUIRING A NEW DONOR")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOUR ORGANIZATION CAN SPEAK OUT—BUT DOES IT?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c18_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - Telling A Story")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHY TELL STORIES?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT IS A STORY?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUNDRAISING STORIES REPORT RESULTS, WITHOUT LINGERING ON YOUR INNER WORKINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANECDOTES VERSUS STATISTICS: WHICH ARE BETTER?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HANDLING THE TROPHY STATISTIC")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("USE STATISTICS LIKE A SPEAR")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAVE THEMES, THEN TELL STORIES THAT ILLUSTRATE THOSE THEMES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT MAKES A STORY WORK? SENSORY DETAIL")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c19_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - Communications and Social Styles")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVERYTHING BUT THE WORDS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT DOES “SOCIAL STYLE” MEAN?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASSERTIVENESS AND RESPONSIVENESS COME FIRST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT’S YOUR SOCIAL STYLE?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ARE YOU COMFORTABLE? ARE OTHERS?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ARE YOU VERSATILE?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A FEW CAVEATS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c20_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - Conversation Nurtures Relationships")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A QUICK ASIDE: QUESTIONS RELATED TO SOLICITATION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURPOSE OF THIS CONVERSATION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HONORING CONVERSATION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STARTING A CONVERSATION: WHY TALKING ABOUT THE WEATHER IS GOOD")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT IS IMPORTANT TO THOSE IN YOUR RELATIONSHIPS?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOUR DONORS AND YOUR MISSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONVERSATION WITH DONORS AT THE RHODE ISLAND FOUNDATION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c21_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - The Case for Support")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRELIMINARY STEPS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A GOOD CASE IS, AT HEART, AN INSPIRING TALE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT KINDS OF INFORMATION TO COLLECT? A CHECKLIST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BUILDING A CASE IN A SINGLE MEETING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOING FROM A TO B: ANSWERING THREE BASIC QUESTIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TYPES OF CASE STATEMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 18A  - Thoughts About Creating a Case for Support")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 18B  - Housatonic Youth Service Bureau")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 18C  - Volunteers in Providence Schools: Case Statement for Operations")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 18D  - Audubon Society of Rhode Island")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c22_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 18E  - Talking Points: HousingWorks RI 2006")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - The Donor Newsletter")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT THE RESEARCH SAYS ABOUT DONOR NEWSLETTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT DO DONORS WANT FROM YOUR NEWSLETTER?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEVEN COMMON FLAWS THAT UNDERMINE DONOR NEWSLETTERS: A CHECKLIST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FLAW YOU FIX FIRST: HEADLINES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW TO FIND THE STORY BEHIND THE HEADLINE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELECTRONS OR PAPER? HIGH-PERFORMANCE E- MAILED NEWSLETTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOUR E-NEWSLETTER’S SUBJECT LINE MAKES ALL THE DIFFERENCE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELECTRONS AND PAPER: OTHER ADVANTAGES OF E-NEWSLETTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E-NEWSLETTERS MUST BE OPT-IN (A GOOD IDEA FOR EVERYTHING, REALLY)")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAST, EASY, STILL ON PAPER: THE “NEWSYLETTER”")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIMPLICITY ITSELF: A PROVEN FORMULA FOR A DONOR NEWSLETTER")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 19A  - Boys & Girls Club of Pawtucket Newsletter")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 19B  - Example 1: Women’s Fund of Rhode Island Newsyletter")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c23_r1#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 19C  - Example 2: Women’s Fund of Rhode Island Newsyletter")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - The Web Site Home Page")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHY WEB SITES ARE COMPLETELY DIFFERENT")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IS YOUR HOME PAGE READY FOR NEWCOMERS?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING OFF ON THE RIGHT FOOT: THE IMPORTANCE OF A TAGLINE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT MUST BE ON THE HOME PAGE, KRUG SAYS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c24_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 -  Tips for Writing")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOUR FIFTH-GRADE TEACHER WAS RIGHT: OUTLINE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AN EASY WAY TO OUTLINE: ASK YOURSELF QUESTIONS FIRST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KNOW THE POINT OF YOUR STORY AND START THERE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WRITE ABOUT BENEFITS, NOT FEATURES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WRITE LESS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WRITE FOR SPEEDY READING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEGINNING WITH A HISTORY LESSON, AND OTHER COMMON FLAWS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c25_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - Readability")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WELCOME, BROWSERS!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW WE LOOK")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROM GUTENBERG TO WHEILDON")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANATOMY OF A FAILED ANNUAL REPORT")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c26_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - Monitoring Progress And Measuring Results")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“IS IT WORKING?” HOW TO MEASURE YOUR RESULTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEASURING THE UNMEASURABLE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GET YOUR THOUGHTS IN ORDER BEFORE YOU BEGIN TO WRITE: A CHECKLIST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVALUATING YOUR DONOR NEWSLETTER: EIGHT TESTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEASURING THE EFFECTIVENESS OF PUBLIC RELATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STANDARDS FOR E-MAIL SOLICITATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c27_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - Monitoring Progress and Measuring Results")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHY EVALUATION MATTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DECIDING WHAT TO MEASURE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEASURING PERFORMANCE AND EVALUATING RESULTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANALYZING AND INTERPRETING EVALUATION RESULTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMUNICATING EVALUATION RESULTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POSSIBLE PERFORMANCE MEASURES FOR RELATIONSHIP BUILDING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONITORING PROGRESS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c28_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERMEZZO #5 -  You and Your Organization: Sprinting into the Future")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c29_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - Coda")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POLITICS OF POWER IN PHILANTHROPY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORAL DILEMMA FACING PHILANTHROPY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POWER, THE SILENT HAUNTING")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNDERSTANDING THE TWO TYPES OF PHILANTHROPY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRADITION DOMINATES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAVE YOU NOTICED: THE LESS SOCIAL JUSTICE WE HAVE, THE MORE PHILANTHROPY WE NEED?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHILANTHROPY AS A DEMOCRATIZING ACT")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ATTACKING THE MORAL DILEMMA")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c30_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 25A  - Questions About Privilege And Power")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ap1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX A - Joyaux’s Concept of Enabling Functions, Skills, and Attitudes")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_ap2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX B - Basic Principles of Fund Development")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5f9e34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aher_9781118044865_oeb_toc_r1.vue
// module id = 57
// module chunks = 0